var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_82)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 38.0001C8 41.0001 8 33.0001 4 32.0001M32 44.0001V36.2601C32.075 35.3064 31.9462 34.3477 31.622 33.4477C31.2979 32.5477 30.7859 31.727 30.12 31.0401C36.4 30.3401 43 27.9601 43 17.0401C42.9995 14.2478 41.9254 11.5625 40 9.54012C40.9117 7.09713 40.8472 4.39682 39.82 2.00012C39.82 2.00012 37.46 1.30012 32 4.96012C27.416 3.71776 22.584 3.71776 18 4.96012C12.54 1.30012 10.18 2.00012 10.18 2.00012C9.15275 4.39682 9.08829 7.09713 10 9.54012C8.06025 11.5775 6.98505 14.287 7 17.1001C7 27.9401 13.6 30.3201 19.88 31.1001C19.222 31.7801 18.7145 32.5909 18.3906 33.48C18.0667 34.369 17.9336 35.3163 18 36.2601V44.0001",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_82"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/Github.f6aa2f469f0fc53253925bfd71032cc1.svg";
export { ForwardRef as ReactComponent };